import { FC, SVGProps } from 'react'

export const Calendar: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M8.5 2.75C8.5 2.33579 8.16421 2 7.75 2C7.33579 2 7 2.33579 7 2.75V4H4.75C4.02065 4 3.32118 4.28973 2.80546 4.80546C2.28973 5.32118 2 6.02065 2 6.75V18.75C2 19.4793 2.28973 20.1788 2.80546 20.6945C3.32118 21.2103 4.02065 21.5 4.75 21.5H18.75C19.4793 21.5 20.1788 21.2103 20.6945 20.6945C21.2103 20.1788 21.5 19.4793 21.5 18.75V6.75C21.5 6.02065 21.2103 5.32118 20.6945 4.80546C20.1788 4.28973 19.4793 4 18.75 4H16.5V2.75C16.5 2.33579 16.1642 2 15.75 2C15.3358 2 15 2.33579 15 2.75V4H8.5V2.75ZM4.75 5.5H7V6.75C7 7.16421 7.33579 7.5 7.75 7.5C8.16421 7.5 8.5 7.16421 8.5 6.75V5.5H15V6.75C15 7.16421 15.3358 7.5 15.75 7.5C16.1642 7.5 16.5 7.16421 16.5 6.75V5.5H18.75C19.0815 5.5 19.3995 5.6317 19.6339 5.86612C19.8683 6.10054 20 6.41848 20 6.75V18.75C20 19.0815 19.8683 19.3995 19.6339 19.6339C19.3995 19.8683 19.0815 20 18.75 20H4.75C4.41848 20 4.10054 19.8683 3.86612 19.6339C3.6317 19.3995 3.5 19.0815 3.5 18.75V6.75C3.5 6.41848 3.6317 6.10054 3.86612 5.86612C4.10054 5.6317 4.41848 5.5 4.75 5.5ZM6.75 10C6.33579 10 6 10.3358 6 10.75C6 11.1642 6.33579 11.5 6.75 11.5H16.75C17.1642 11.5 17.5 11.1642 17.5 10.75C17.5 10.3358 17.1642 10 16.75 10H6.75Z"
			fill="currentColor"
		/>
	</svg>
)
